import { ProjectModule } from "@/store/modules/project.module";
import { toaster } from "@/utilities/toaster";
import { Machine } from "xstate";
const projectAnalyticsDetailsMachine = Machine({
    id: "projectAnalyticsDetailsMachine",
    context: {
        selectedProjectId: null,
        operationIndex: 0,
        operationType: "",
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "modalDormant",
            },
        },
        modalDormant: {
            on: {
                GETTING_PROJECT_ANALYTICS_DETAILS: { target: "modalActive", actions: "addDateRangeFilter" },
            },
        },
        modalActive: {
            initial: "parallelStates",
            on: {
                MAKE_MODAL_DORMANT: { target: "modalDormant" },
            },
            states: {
                parallelStates: {
                    type: "parallel",
                    states: {
                        getProjectAnalyticsDetails: {
                            tags: "getProjectAnalyticsDetails",
                            invoke: {
                                id: "getProjectAnalyticsDetails",
                                src: (context, event) => {
                                    return ProjectModule.GetProjectAnalyticById({ projectId: context.selectedProjectId, operation: context.operationType });
                                },
                                onDone: { target: "#projectAnalyticsDetailsMachine.modalActive.loadedProjectAnalyticsDetails" },
                                onError: { target: "#projectAnalyticsDetailsMachine.serviceUnavailable" },
                            },
                        },
                        gettingTotalTimeOftheProject: {
                            invoke: {
                                id: "gettingTotalTimeOftheProject",
                                src: (context, event) => {
                                    return ProjectModule.GetTotalTimeForProject(context.selectedProjectId);
                                },
                                onDone: { target: "#projectAnalyticsDetailsMachine.modalActive.loadedProjectAnalyticsDetails" },
                                onError: { target: "#projectAnalyticsDetailsMachine.serviceUnavailable" },
                            },
                        },
                    },
                },
                loadedProjectAnalyticsDetails: {
                    tags: "getProjectAnalyticsDetails",
                    on: {
                        GETTING_PROJECT_ANALYTICS_DETAILS: { target: "#projectAnalyticsDetailsMachine.modalActive.parallelStates.getProjectAnalyticsDetails", actions: "addDateRangeFilter" },
                        ON_TAB_CHANGE: { target: "gettingProjectDetailsOnTabChange", actions: "addDateRangeFilter" },
                    },
                },
                gettingProjectDetailsOnTabChange: {
                    invoke: {
                        id: "gettingProjectDetailsOnTabChange",
                        src: (context, event) => {
                            return ProjectModule.GetProjectanalyticsTeamMemberDetails({ projectId: context.selectedProjectId, operation: context.operationType });
                        },
                        onDone: { target: "loadedProjectAnalyticsDetails" },
                        onError: { target: "#projectAnalyticsDetailsMachine.serviceUnavailable" },
                    },
                },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        addDateRangeFilter: (context, event) => {
            const bTabIndex = context.operationIndex;
            const onTabChange = (bTabIndex) => {
                var tabChangeValue = {
                    0: "allTime",
                    1: "thisWeek",
                    2: "lastWeek",
                    3: "thisMonth",
                    4: "lastMonth",
                };
                if (tabChangeValue[bTabIndex]) {
                    context.operationType = tabChangeValue[bTabIndex];
                }
            };
            return onTabChange(bTabIndex);
        },
    },
    guards: {},
    activities: {},
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
    },
});
export default projectAnalyticsDetailsMachine;
